import PricingActionsCard from './PricingActionsCard'

export default PricingActionsCard
